import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/Common";
import { Button } from "@/components/ui/button";
import { Bell, CheckCheck, MessageSquare, ReceiptText, CheckCircle2, Send, Inbox } from "lucide-react";

const ICONS = {
  negotiation: MessageSquare, invoice: ReceiptText, decision: CheckCircle2, quotation_sent: Send, request: Inbox,
};

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };
  const markOne = async (id) => { await api.post(`/notifications/${id}/read`); load(); };

  return (
    <div data-testid="notifications-page">
      <PageHeader overline="Pusat Informasi" title="Notifikasi">
        <Button data-testid="mark-all-read" onClick={markAll} variant="outline" className="rounded-sm">
          <CheckCheck className="w-4 h-4 mr-2" /> Tandai semua dibaca
        </Button>
      </PageHeader>
      <div className="p-8 max-w-3xl">
        <div className="space-y-2">
          {items.length === 0 && (
            <div className="border border-border rounded-sm p-12 text-center text-muted-foreground">
              <Bell className="w-6 h-6 mx-auto mb-2 opacity-50" />Belum ada notifikasi.
            </div>
          )}
          {items.map((n) => {
            const Icon = ICONS[n.type] || Bell;
            return (
              <div
                key={n.id}
                data-testid={`notification-${n.id}`}
                onClick={() => !n.read && markOne(n.id)}
                className={`flex items-start gap-3 p-4 border rounded-sm cursor-pointer transition-colors ${
                  n.read ? "border-border bg-card" : "border-accent/40 bg-accent/5 hover:bg-accent/10"
                }`}
              >
                <div className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-sm ${n.read ? "bg-secondary" : "bg-accent text-accent-foreground"}`}>
                  <Icon className="w-4 h-4" />
                </div>
                <div className="flex-1">
                  <div className="font-medium text-sm">{n.title}</div>
                  <div className="text-sm text-muted-foreground">{n.message}</div>
                  <div className="overline text-muted-foreground mt-1">{new Date(n.created_at).toLocaleString("id-ID")}</div>
                </div>
                {!n.read && <span className="w-2 h-2 rounded-full bg-accent mt-2" />}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
